import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDialogModule } from '@angular/material/dialog';

export const ANGULAR_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule,
  RouterModule,
];

export const ANGULAR_MATERIAL_MODULES = [
  MatInputModule,
  MatButtonModule,
  MatCardModule,
  MatFormFieldModule,
  MatIconModule,
  MatTooltipModule,
  MatDialogModule,
];

export const OTHER_CORE_LIBS_MODULES = [TranslocoModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...ANGULAR_MATERIAL_MODULES, ...OTHER_CORE_LIBS_MODULES],
  exports: [...ANGULAR_MODULES, ...ANGULAR_MATERIAL_MODULES, ...OTHER_CORE_LIBS_MODULES],
})
export class CoreModule {}
